import { useGetNextBoardMeeting } from "@/api/next-board-meeting";
import { CardWithTitle, Loader } from "@/ui/components";

const DashboardNextBoardMeeting = () => {
  const { nextBoardMeeting, nextBoardMeetingLoading, nextBoardMeetingEmpty } =
    useGetNextBoardMeeting();

  return (
    <>
      <CardWithTitle
        className="m-2"
        header={
          <>
            {!nextBoardMeetingLoading && nextBoardMeetingEmpty && (
              <p className="no-data text-left text-lf-red-dark">
                No upcoming Board Meeting
              </p>
            )}
            {!nextBoardMeetingLoading && nextBoardMeeting && (
              <h2 className="text-xl font-bold uppercase">
                {nextBoardMeeting.eyebrow}
              </h2>
            )}
          </>
        }
      >
        {nextBoardMeetingLoading && <Loader text={"next board meeting"} />}
        {!nextBoardMeetingLoading && nextBoardMeeting && (
          <h1 className="text-3xl font-bold uppercase text-lf-blue-light-3">
            {nextBoardMeeting.title}
          </h1>
        )}
      </CardWithTitle>
    </>
  );
};

export default DashboardNextBoardMeeting;
